import { useMemo } from 'react';
import { keyBy } from 'es-toolkit';
// mantine
import { Loader } from '@mantine/core';
// components
import VoiceForm from '@/pages/Settings/components/Voice/components/VoiceForm';
import NoRecords from '@/components/NoRecords';
// utils
import {
    useIntegrationByIdnQuery,
    useByIntegrationIdnConnectorsQuery
} from '@/services/integration/integration.queries';
import { buildSchema } from '@/pages/Settings/Settings.utils';

const Voice = () => {
    const { data: integration, isLoading: isLoadingIntegration } =
        useIntegrationByIdnQuery('newo_voice');
    const {
        data: connectors = [],
        isLoading: isLoadingConnectors,
        isSuccess
    } = useByIntegrationIdnConnectorsQuery('newo_voice');

    const settings = useMemo(() => {
        if (integration?.connector_settings_descriptions) {
            return keyBy(
                integration.connector_settings_descriptions,
                (item) => item.idn
            );
        }
        return {};
    }, [integration]);

    const schema = useMemo(() => {
        if (integration?.connector_settings_descriptions) {
            return buildSchema(integration.connector_settings_descriptions);
        }
        return {};
    }, [integration]);

    return (
        <div className="flex flex-col gap-4 pt-4">
            {isLoadingIntegration || isLoadingConnectors ? (
                <div className="flex justify-center items-center py-24">
                    <Loader />
                </div>
            ) : undefined}

            {isSuccess && connectors.length === 0 ? <NoRecords /> : undefined}

            {connectors.map((connector) => (
                <VoiceForm
                    connector={connector}
                    key={connector.connector_idn}
                    schema={schema}
                    settingsDescription={settings}
                />
            ))}
        </div>
    );
};

export default Voice;
